import React from "react";
import { Typography, Grid } from "@mui/material/";
import CircleIcon from "../../../../../common/components/CircleIcon";
import { helpers } from "../../../../../common/lib";
import { camelize } from "humps";

export const getIdentifiers = ({
    identifier1,
    identifier2,
    identifier3,
    identifier4
}) => ({
    identifiers: [identifier1, identifier2, identifier3, identifier4].join(""),
    identifiersList: [identifier1, identifier2, identifier3, identifier4]
});

/** Render circle  for row value which has boolean value */
export const renderCircle = (rowVal) => {
    let value;
    if (rowVal && rowVal.toLowerCase() === "pass") value = true;
    else if (rowVal && rowVal.toLowerCase() === "fail") value = false;
    else value = "none";
    return (
        <>
            <Typography style={{ fontSize: 0 }}>{rowVal}</Typography>
            <CircleIcon value={value} />
        </>
    );
};

/** Filter options for boolean values for null value we have used none*/

export const customBooleanFilterOptions = ["pass", "fail", "none"];

/** check status if it is expected, unexpected or validated visibility assets */

export const checkStatuses = (statuses) => {
    let next;
    statuses.map((status) => {
        if (status.startsWith("unexpected")) {
            next = "unexpected";
        } else if (status.startsWith("expected")) {
            next = "expected";
        } else if (status.startsWith("validatedVisibility")) {
            next = "validatedVisibility";
        } else if (status.startsWith("nonMandatory")) {
            next = "nonMandatory";
        } else {
            return `${status} does not match any known categories`;
        }
    });
    return next;
};

export const isResolvableAsset = (asset) => {
    const isResolved = asset?.isResolved === true ? true : false;

    const isMatchAccepted = () => {
        /** if asset has 0 matches and and asset is not resolved */
        if (
            asset?.isMatched === undefined &&
            asset?.assetMatches?.length === 0 &&
            !asset?.isResolved
        )
            return true;
        /** if asset has more than 1 matches and and asset is not resolved */ else if (
            asset?.isMatched === undefined &&
            asset?.assetMatches?.length > 0 &&
            !asset.isResolved
        ) {
            return false;
        } /** if asset has no matches and and asset is not resolved */ else {
            return true;
        }
    };

    return !isResolved && isMatchAccepted();
};

export const getAssetTypeValidationRules = (
    typeId,
    validationRules,
    validationFields
) => {
    if (typeId) {
        return validationRules
            .filter((item) => item.assetTypeId === typeId)
            .reduce((aggregate, rule) => {
                const field = validationFields.find(
                    (item) => item.id === rule.fieldId
                );

                return { ...aggregate, [camelize(field.value)]: rule };
            }, {});
    } else return {};
};

export const vinCheck = (asset, typesList) => {
    const { identifier1 } = asset;
    const { invalidIdentifiers, validationRules, validationFields } = typesList;

    /** If not rejecting validate VIN */
    if (identifier1 && identifier1.length >= 7 && identifier1.length < 18) {
        // const name = Object.keys({ identifier1 })[0];
        const name = "identifier1";

        const rules = getAssetTypeValidationRules(
            asset.type,
            validationRules.data,
            validationFields.data
        );

        const invalidKey = invalidIdentifiers.data.find(
            (item) => item.name.toUpperCase() === identifier1.toUpperCase()
        );

        const regex = helpers.regex.parseString(rules[name].regex);
        // If there are no rules then it is unknown
        if (!regex) {
            // Check for the basic vin check
            const reg = helpers.regex.parseString("/^[0-9A-HJ-NPR-Z]+$/i");
            return reg.test(identifier1);
        }

        if (regex && regex.test(identifier1) && invalidKey === undefined) {
            return true;
        }
    }
    return false;
};

export default {
    getIdentifiers,
    renderCircle,
    customBooleanFilterOptions,
    getAssetTypeValidationRules,
    isResolvableAsset,
    vinCheck
};
